import { defineStore } from 'pinia';
import store from '@/store';
import { GETTER_COMPOSITION_COMPOSITION } from '@/store/modules/composition/getters';
import {
  MUTATION_COMPOSITION_UPDATE_SIDE_CONTENT,
  MUTATION_COMPOSITION_UPDATE_SIDE_PRINTSTYLE
} from '@/store/modules/composition/mutation-types';

export const useCompositionStore = defineStore('composition', {
  getters: {
    composition() {
      return store.getters[GETTER_COMPOSITION_COMPOSITION];
    },
    sides(state) {
      return Object.keys(state.composition.printPlates);
    },
    printStyle(side) {
      return this.composition.printPlates[side].printStyle;
    }
  },
  actions: {
    getElementByUid(uid) {
      const printplates = this.composition.printPlates;
      for (const side in printplates) {
        const foundElement = printplates[side].content.find(
          element => element.uid === uid
        );
        if (undefined !== foundElement) {
          return foundElement;
        }
      }
      return null;
    },
    getPrintSideContent(side) {
      return this.composition.printPlates[side];
    },
    getPrintSideNameOfElement(uid) {
      const printplates = this.composition.printPlates;
      for (const side in printplates) {
        const foundElement = printplates[side].content.find(
          element => element.uid === uid
        );
        if (undefined !== foundElement) {
          return side;
        }
      }
      return null;
    },
    updateElement(uid, changeset) {
      // Remove fields which are not allowed to be changed.
      delete changeset.uid;

      const side = this.getPrintSideNameOfElement(uid);
      if (null === side) {
        return;
      }
      const printSide = this.getPrintSideContent(side);

      store.commit(MUTATION_COMPOSITION_UPDATE_SIDE_CONTENT, {
        side,
        content: printSide.content.map(element => {
          if (uid !== element.uid) {
            return element;
          }
          const elementCopy = { ...element };
          for (const prop in changeset) {
            if (!Object.prototype.hasOwnProperty.call(elementCopy, prop)) {
              continue;
            }
            elementCopy[prop] = changeset[prop];
          }
          return elementCopy;
        })
      });
    },
    addElement(side, element) {
      store.commit(MUTATION_COMPOSITION_UPDATE_SIDE_CONTENT, {
        side,
        content: [...this.getPrintSideContent(side).content, element]
      });
    },
    removeElement(uid) {
      const side = this.getPrintSideNameOfElement(uid);
      store.commit(MUTATION_COMPOSITION_UPDATE_SIDE_CONTENT, {
        side,
        content: this.getPrintSideContent(side).content.filter(
          item => item.uid !== uid
        )
      });
    },
    updateSideContent(side, content) {
      store.commit(MUTATION_COMPOSITION_UPDATE_SIDE_CONTENT, {
        side,
        content: content
      });
    },
    updateSidePrintStyle(side, printStyle) {
      store.commit(MUTATION_COMPOSITION_UPDATE_SIDE_PRINTSTYLE, {
        side,
        printStyle
      });
    }
  }
});
